import React, { useState, useImperativeHandle, forwardRef } from "react";
import Navigation from "./index";
import "./NavigationMobile.css";

const MobileNavDrawer = forwardRef(({
                                        socketCallbackFunction,
                                        isCallbackNeeded,
                                        handlerFunction,
                                        errorHandler,
                                    }, ref) => {
    const [isNavOpen, setIsNavOpen] = useState(false);

    const openDrawer = () => setIsNavOpen(true);
    const closeDrawer = () => setIsNavOpen(false);

    useImperativeHandle(ref, () => ({
        openDrawer,
        closeDrawer,
    }));

    return (
        <div className={`mobile-nav-container d-block d-md-none ${isNavOpen ? "open" : ""}`}>
            <div className="mobile-nav-overlay" onClick={closeDrawer}></div>
            <div className="mobile-nav-content">
                <Navigation
                    socketCallbackFunction={socketCallbackFunction}
                    isCallbackNeeded={isCallbackNeeded}
                    handlerFunction={handlerFunction}
                    errorHandler={errorHandler}
                    onClose={closeDrawer} // ✅ explicitly pass it
                />
            </div>
        </div>
    );
});

export default MobileNavDrawer;
